import { render, staticRenderFns } from "./EventSns.vue?vue&type=template&id=31b10eef&"
import script from "./EventSns.vue?vue&type=script&lang=js&"
export * from "./EventSns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports